import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import AccountCreationForm from '../add-member-modal/account-creation-form';

@inject('userStore')
@observer
class FanSignUpForm extends React.Component {

	state = {
		success: false,
		isValid: false,
	}

	constructor (props) {
		super(props);

		const {userStore} = props;

		this.user = userStore.newUser({
			...userStore.newFBUserData,
			role: userStore.roles.SUBSCRIBER
		});
	}

	render () {
		return (
			<div className="grid-x">
				<div className="large-12">
					{ this.state.success ? this.renderConfirmationCode() : this.renderForm() }
				</div>
			</div>
		);
	}

	renderForm () {

		return (
			<div id="signUpForm" className="center-login">
				<AccountCreationForm user={this.user} submitDisabled={this.submitDisabled} afterSubmit={this.afterSubmit} />
			</div>
		);
	}

	renderConfirmationCode () {

		return (
			<div id="signUpForm" className="center-login">
				<div className="grid-x grid-padding-x" style={{height:'100vh', backgroundColor:'transparent'}}>
					<div className="grid-x align-middle align-center" style={{justifyContent:"center", width:"100%", textAlign:"center", flexDirection:"column"}}>
						<div className="admin-title" data-ta="confirmationCodeTitle">Just one more step!</div>
						<br/>
						<div>Check your email for a confirmation link!</div>
						<Link className="muz-link" to={{pathname: "/login"}}>Return to login</Link>
					</div>
				</div>
			</div>
		);
	}
	@autobind
	afterSubmit () {
		this.setState({success:true});
	}
	
};


export default FanSignUpForm;
